import React, {useContext} from "react";
import "./Progress.scss";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import LanguageContext from "../../contexts/LanguageContext";
import {translations} from "../../translations";

export default function StackProgress() {
  const {isDark} = useContext(StyleContext);
  const {isEnglish} = useContext(LanguageContext);
  const currentLang = isEnglish ? translations.en : translations.pt;
  const {title, columns} = currentLang.areasOfImpact;

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="impact-section" id="areas-of-impact">
        <h1 className={isDark ? "dark-mode impact-heading" : "impact-heading"}>
          {title}
        </h1>
        <div className="impact-grid">
          {columns.map((col, i) => (
            <div
              key={i}
              className={isDark ? "impact-card impact-card-dark" : "impact-card"}
            >
              <h2 className="impact-card-heading">{col.heading}</h2>
              <p
                className={
                  isDark
                    ? "dark-mode subTitle impact-card-items"
                    : "subTitle impact-card-items"
                }
              >
                {col.items}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Fade>
  );
}
